module.exports = __webpack_public_path__ + "img/hong_kong.7fa91885.png";